import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx'; 
import * as $ from 'jquery';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexFill,
  ApexGrid,
  ApexTooltip,
  ApexPlotOptions,
  ApexNonAxisChartSeries,
  ApexLegend,
  ApexYAxis,
  ApexAnnotations,
  ApexResponsive,
  ApexMarkers,
} from "ng-apexcharts";
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { InstituteDashboardDetailsService } from 'src/app/Services/institute-dashboard-details.service';
import { ToastrService } from 'ngx-toastr';
const EXCEL_TYPE='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION='.xlsx';

export type StudentFacultyAssessment = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
};
export type Specializations = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  colors: string[];
  responsive: ApexResponsive[];
  legend: ApexLegend;
  fill: ApexFill;
  plotOptions: ApexPlotOptions;
  dataLabels: ApexDataLabels;
};
export type TotalParticipation = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  colors: string[];
  plotOptions: ApexPlotOptions;
  legend: ApexLegend;
  dataLabels: ApexDataLabels;
};

export type GraphArea = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  colors: string[];
  markers: ApexMarkers; 
  legend: ApexLegend; 
};

@Component({
  selector: 'app-gap-analysis-dashboard',
  templateUrl: './gap-analysis-dashboard.component.html',
  styleUrls: ['./gap-analysis-dashboard.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class GapAnalysisDashboardComponent implements OnInit {

  color = '#26B99A';
  mode = 'determinate';
  value = 50;
  bufferValue = 75;

  @ViewChild("chart") chart: ChartComponent;
  public StudentFacultyAssessment: Partial<StudentFacultyAssessment>;
  public GraphArea: Partial<GraphArea>;
  public Specializations: Partial<Specializations>;
  public TotalParticipation: Partial<TotalParticipation>;


  displayedColumns = ['StudentId', 'Name', 'Discipline', 'Batch', 'Year', 'ContactInfo'];
  dataSource: MatTableDataSource<Element>;

  @ViewChild('MatPaginator', { static: false }) paginator: MatPaginator;
  @ViewChild('sort', { static: false }) sort: MatSort;
  
  expandedElement: any;
  



  constructor(
    private instituteDashboardService: InstituteDashboardDetailsService,
    private toastr: ToastrService,
  ) { 

    this.StudentFacultyAssessment = {
      series: [
        {
          name: "Assessments by Institute",
          data: [0,0,0,0,0,0]
        },
        {
          name: "Self-Assessments",
          data: [0,0,0,0,0,0]
        }
      ],
      chart: {
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        type: "bar",
        height: 300,
        width: '98%',
        toolbar: {
          show: false
         }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "75%",
        }
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },

      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
        ],
        title: {
          text: 'Months',
        }
      },
      legend: {
        position: "top",
        markers: {
          fillColors: ['#26B99A', '#03586A']
          // fillColors: ['#26B99A']
        },
      },
      yaxis: {
        title: {
          text: 'Number of Students',
          offsetX: 0,
          offsetY: 0,
          style: {
              color: undefined,
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              cssClass: 'apexcharts-xaxis-title',
          },
        },
        labels: {
          
        }
      },
      fill: {
        opacity: 1,
        colors: ['#26B99A', '#03586A']
        // colors: ['#26B99A']
      },
      tooltip: {
        y: {
          formatter: function(val) {
            if(val<2){
              return val + " Student";
            }else{
              return val + " Students";
            }
          }
        }
      }
    };
    this.Specializations = {
      // series: [44, 55, 13, 43, 22],
      series: [],
      chart: {
        id: 'Specializations',
        redrawOnParentResize: true,
        redrawOnWindowResize: true,        
        height: 325,
        width: '100%',
        type: "donut"
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '10px',
          colors: ['white']
        },
      },
      labels: ['Student 1', 'Student 2', 'Student 3', 'Student 4', 'Student 5'],
      plotOptions: {
        pie: {
          donut: {
            size: '50%'
          }
        }
      },
      
      colors: ["#3598db", "#26ba9a", "#e84c3d", "#9a59b5", "#2874A6" ,"#bec3c7"],
      legend: {
        show: true,

        labels: {
          useSeriesColors: false
        },
        formatter: function(val, opts) {
          // alert(opts);
          return val + " -- " + opts.w.globals.series[opts.seriesIndex];
        },
        itemMargin: {
          horizontal: 3
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              redrawOnParentResize: true,
              redrawOnWindowResize: true,              
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    };
    this.TotalParticipation = {
      series: [68],
      chart: {
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        type: "radialBar",
        offsetY: -20,
        height: 300,
        width: '100%',
      },
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: "#e7e7e7",
            strokeWidth: "97%",
            margin: 5, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: 2,
              left: 0,
              opacity: 0.31,
              blur: 2
            }
          },
          dataLabels: {
            show: false,
            name: {
              show: false,
            },
            value: {
              offsetY: -2,
              fontSize: "22px"
            }
          }
        }
      },
      colors: ["#26B99A"],
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
    };
    this.GraphArea = {
      series: [
        // {
        //   name: "series1",
        //   data: [31, 40, 28, 51, 42, 83, 100, 31, 40, 28, 92, 42]
        // },
        // {
        //   name: "series2",
        //   data: [11, 32, 45, 32, 84, 52, 41, 11, 32, 45, 32, 34]
        // },
        // {
        //   name: "series3",
        //   data: [21, 42, 55, 42, 44, 62, 51, 74, 42, 55, 42, 44]
        // },
        // {
        //   name: "series4",
        //   data: [41, 42, 81, 42, 44, 62, 51, 41, 42, 55, 42, 54]
        // }
      ],
      chart: {
        id: 'graphArea',
        redrawOnParentResize: true,
        redrawOnWindowResize: true,
        height: 250,
        width: '100%',
        type: "area",
        toolbar: {
          show: false,
        }
      },
      dataLabels: {
        enabled: false
      },
      colors: ['#fefa7c', '#39be9d', '#765e6e', '#f97070'],
      stroke: {
        width: 3,
        curve: "smooth"
      },
      markers: {
        size: 4,
        strokeWidth: 0,
        hover: {
          size: 7
        }
      },
      legend: {
        show: false,
      },
      xaxis: {
        title: {
          text: 'Months',
          offsetX: 0,
          offsetY: 0,
          style: {
              color: undefined,
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              cssClass: 'apexcharts-xaxis-title',
          },
        },
        labels: {
          rotate: -45,
          rotateAlways: true,
          style: {
            fontSize: '10px',
            fontWeight: 400,
          },
        },
        type: "category",
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        
        // overwriteCategories: [
        //   'Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        // ],
      },
      yaxis: {
        title: {
          text: 'Number of Students',
          offsetX: 0,
          offsetY: 0,
          style: {
              color: undefined,
              fontSize: '12px',
              fontFamily: 'Helvetica, Arial, sans-serif',
              fontWeight: 600,
              cssClass: 'apexcharts-xaxis-title',
          },
        },
        tickAmount: 10,
        min: 0,
        max: 100,
      },
      tooltip: {
        y: {
          formatter: function(val) {
            if(val<2){
              return val + " Student"
            }else{
              return val + " Students";
            }
          }
        }
      }
    };

    this.dataSource = new MatTableDataSource();

  }

  dashboardCounts:any=[];
  dashboardData:any=[];
  departments:any=[];
  departmentPerformance:any=[];
  departmentWisePerformance:any=[];
  ratings:any=[];
  yearWisePerformance:any=[];
  totalParticipation:any=[];
  studentData:any=[];
  finalData:any=[];
  excelTitle:any;
  heading:string;
  
  studentPerformanceDept:any=0;
  topSpecsDept:any=1;
  totalParticipationDept:any=0;

  sidemenu: any = 'Institute';
  Institute: any;
  Student: any;
  Gap: any;

  ngOnInit(): void {
    // $(window).resize(function() {
    //   const tableWidth = document.getElementById('table').clientWidth;
    //   const cellWidth = document.getElementsByTagName('mat-cell')[0].clientWidth;
    // });
    this.instituteDashboardService.gapAnalysisCount().subscribe(data=>this.setCounts(data));
    this.instituteDashboardService.getLowDepartmentPerformance().subscribe(data=>this.setLowPerformanceValue(data))
    this.instituteDashboardService.getInstituteDepartment().subscribe(data=>this.departments=data['getDepartment']);
    this.instituteDashboardService.lowSpecialization(1).subscribe(data=>this.setLowTopic(data));
    this.instituteDashboardService.lowAverageStudentGraph().subscribe(data=>this.setLowAvgStudentScore(data));
    this.instituteDashboardService.yearWiseLowPerformance().subscribe(data=>this.setYearWisePerformance(data));
    this.instituteDashboardService.totalLowParticipation(null).subscribe(data=>this.setParticipation(data));
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;   
    
    this.dataSource.filterPredicate = this.filterObject;
  }

  onCountsClick(data){
    this.excelTitle=data;
    if(data=='notRegistered'){
      this.heading='Not Registered';
    }else if(data=='profileNotSubmitted'){
      this.heading='Profile Not Submitted';
    }else if(data=='notVerified'){
      this.heading='Not Verified';
    }else if(data=='assessmentNotAssigned'){
      this.heading='Assessment Not Assigned';
    }else if(data=='assessmentNotTaken'){
      this.heading='Assessment Not Taken';
    }
    if(this.dashboardData[data]){
      this.studentData=this.dashboardData[data];
      this.dataSource.data=this.dashboardData[data];
      this.dataSource.filterPredicate = this.filterObject;
    }
  }

  setCounts(data){
    if(data['type']=="Success"){
      this.dashboardCounts=data['counts'];
      this.dashboardData=data['data'];
      this.onCountsClick('notRegistered');
    }else{
      this.toastr.error(data['message']);
    }
  }
  setLowAvgStudentScore(data){
    if(data['type']=="Success"){
      this.StudentFacultyAssessment.series[0].data=data['totalAssessmentStudent'];
      this.StudentFacultyAssessment.series[1].data=data['totalSelfAssessmentStudent'];
      this.StudentFacultyAssessment.xaxis={'categories':data['months'], 'title': {text: 'Months'}};
      }else{
        this.toastr.error(data['message']);
      }
  }
  
  onDepartmentSelect(val){
    if(val.target.value==0){
      this.instituteDashboardService.getLowDepartmentPerformance().subscribe(data=>this.updateRating(data['ratings']));
    }else{
      this.instituteDashboardService.getDepartmentWiseLowPerformance(val.target.value).subscribe(data=>this.updateRating(data['ratings']));
    }
  }

  setLowPerformanceValue(data){
    if(data['type']="Success"){
      if(data['marksDeptPerformance']){
        this.departmentPerformance=data['marksDeptPerformance'];
      }
      // this.departmentPerformance[0]['avg']=23;
      this.updateRating(data['ratings']);
    }else{
      this.toastr.error(data['message']);
    }
  }

  updateRating(data){
    this.ratings=data;
  }

  onDeptChangeTopic(value){
    this.instituteDashboardService.lowSpecialization(value.target.value).subscribe(data=>this.setLowTopic(data));
  }

  setLowTopic(data){
    var series=[];
    var topic=[];
    var others=0;
    var i=0;
    if(data['marksTopicPerformance']){
      data['marksTopicPerformance'].forEach(element => {
        if(i<5){
          series.push(element['avg']);
          topic.push(element['Topic']);
          i++;
        }
        // else{
        //   others=others+element['avg'];
          
        // }
      });
      // series.push(Math.floor(others));
      // topic.push('Others');
      
      this.Specializations['series']=series;
      this.Specializations['labels']=topic;
    }else{
      this.Specializations['series']=[];
      this.Specializations['labels']=[];
    }
  }
  
  setYearWisePerformance(data){
    if(data['type']=="Success"){
      this.yearWisePerformance=data['yearWisePerformance'];
      this.GraphArea.series=[
        {name:'First Year',data:this.yearWisePerformance['firstYearCount']},
        {name:'Second Year',data:this.yearWisePerformance['secondYearCount']},
        {name:'Third Year',data:this.yearWisePerformance['thirdYearCount']},
        {name:'Fourth Year',data:this.yearWisePerformance['fourthYearCount']}
      ]
    }else{
      this.toastr.error(data['message']);
    }
  }

  onDeptChangeParticipants(data){
    if(data.target.value=="null"){
      this.instituteDashboardService.totalLowParticipation(null).subscribe(data=>this.setParticipation(data));
    }else{
      this.instituteDashboardService.totalLowParticipation(data.target.value).subscribe(data=>this.setParticipation(data));
    }
  }
  setParticipation(data){
    if(data['type']=="Success"){
      this.totalParticipation=data['totalParticipation'];
      this.TotalParticipation.series=[this.totalParticipation['percentage']];
    }else{
      this.toastr.error(data['message']);
    }
  }

  onClick(check) {
    if (check == 'Institute') {
      this.sidemenu = 'Institute';
    } else if (check == 'Student') {
      this.sidemenu = 'Student';
    } else {
      this.sidemenu = 'Gap';
    }
  }
  
  onDeptChangeforAll(data){
    this.totalParticipationDept=data.value;
    this.studentPerformanceDept=data.value;

    if(data.value==0){
      this.topSpecsDept=1;
      this.instituteDashboardService.getLowDepartmentPerformance().subscribe(data=>this.setLowPerformanceValue(data))
      this.instituteDashboardService.lowSpecialization(1).subscribe(data=>this.setLowTopic(data));
      this.instituteDashboardService.totalLowParticipation(null).subscribe(data=>this.setParticipation(data));
    }else{
      this.topSpecsDept=data.value;
      this.instituteDashboardService.lowSpecialization(data.value).subscribe(data=>this.setLowTopic(data));
      this.instituteDashboardService.getDepartmentWiseLowPerformance(data.value).subscribe(data=>this.updateRating(data['ratings']));
      this.instituteDashboardService.totalLowParticipation(data.value).subscribe(data=>this.setParticipation(data));
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  filterObject(obj, filter):boolean{
    return filter.split(' ').some(
      item => obj['student_id'].toLowerCase().indexOf(item) >= 0 || 
              obj['name'].toLowerCase().indexOf(item) >= 0 || 
              // obj['enrollment_number'].toLowerCase().indexOf(item) >= 0 || 
              obj['course'].toLowerCase().indexOf(item) >= 0 || 
              // obj['email'].toLowerCase().indexOf(item) >= 0 || 
              // obj['mobile'].toLowerCase().indexOf(item) >= 0 ||
              obj['date_of_addmission'].toLowerCase().indexOf(item) >= 0
    );
  }

  public exportAsExcelFile(): void {
    this.finalData=[];
    this.studentData.forEach(element => {
      var student = {
        'Student id': '', 'Name': '', 'Email': '', 'Mobile': '', 'Discipline': '', 'Batch': '', 
        'Current Year' : ''
      };

      student['Student id'] = element.student_id;
      student['Name'] = element.name;
      student['Email'] = element.email;
      student['Mobile'] = element.mobile;
      student['Discipline'] = element.course;
      student['Batch'] = element.date_of_addmission;
      student['Current Year'] = element.current_year;
      
      this.finalData.push(student);
    });

    var excelFileName= 'Students_'+this.excelTitle;
    var workbook: XLSX.WorkBook;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.finalData);
    workbook = { Sheets: { 'Students': worksheet }, SheetNames: ['Students'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  favoriteSeason: string = 'notRegistered';
  readioSelected:any;
  showcontent:boolean=false;
  showContent(){
    this.showcontent=this.readioSelected;
  }


}


// export interface Element {
//   Name: string;
//   StudentId: string;
//   Discipline: string;
//   Batch: string;
//   Email: string;
//   Mobile: number;
//   Year: string;
// }

// const data: Element[] = [
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },
//   { StudentId: 'S-12309', Name: 'Nishant Jain', Discipline: 'Computer Science', Batch: '2017-18', Email: 'nishantjain@aicte-india.org', Mobile: 9876543210, Year: '2nd' },

// ];

function reviewText() {
  throw new Error('Function not implemented.');
}

